export class PageControl {
  pageSize = 10;
  sortDirection?: "DESC" | "ASC";
  sortField?: string;
  page = 0;
  param?: string;
  value?: any;
  pagesArray?: any[] = [];
  noOrder?: boolean;
}
